import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_REVISIONS: createSagaAction('GET_REVISIONS')
}

// Action Creators
export const actions = {
  // implemented after get right way to fetch revisions from legacy system
  getRevisions: ({ targetId, table }) => ({
    type: constants.GET_REVISIONS.ACTION,
    targetId,
    table
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.GET_REVISIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_REVISIONS.SUCCESS:
      return {
        ...state,
        revisions: action.payload.data,
        loading: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/revisionActions.js